
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Colorectal_polyp',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/Colorectal_polyp.vue